import { render, staticRenderFns } from "./ModalCamposPersonalizadosItemOportunidade.vue?vue&type=template&id=6b64dd3c"
import script from "./ModalCamposPersonalizadosItemOportunidade.vue?vue&type=script&lang=js"
export * from "./ModalCamposPersonalizadosItemOportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports